/**
 * Poort voor dev-only onderdelen in het scherm (besluit Q1, fixronde oktober
 * 2026): `REACT_APP_EXPERTISEPUNT_ENV=dev`, als build-arg meegegeven door
 * deploy-dev.yml (nooit NODE_ENV — de gedeployde dev draait met
 * NODE_ENV=production). Extra zekerheid: de hostnaam van de dev-omgeving, voor
 * het geval de build-arg ooit wegvalt. Productie en de lokale stack krijgen
 * geen van beide en zien dus niets; lokaal zet je de variabele desgewenst in
 * een gitignored `frontend/.env.local`.
 *
 * Dit regelt alleen zichtbaarheid; de echte afscherming zit in de backend
 * (`DevOnlyGuard`).
 */
export const isDevOmgeving = (): boolean =>
  process.env.REACT_APP_EXPERTISEPUNT_ENV === "dev" ||
  (typeof window !== "undefined" &&
    window.location.hostname === "dev.expertisepunt.com");